import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const BrandContext = createContext(null);

const STORAGE_KEY = 'bi_vip_active_brand';

export function BrandProvider({ children, brands = [], onBrandChange }) {
  const [activeBrand, setActiveBrandState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || null;
  });

  // When brands list changes (after /api/me loads), ensure activeBrand is valid
  useEffect(() => {
    if (brands.length === 0) return;
    const stored = localStorage.getItem(STORAGE_KEY);
    const valid = brands.find(b => b.key === stored);
    if (!valid) {
      const first = brands[0].key;
      localStorage.setItem(STORAGE_KEY, first);
      setActiveBrandState(first);
    }
  }, [brands]);

  const setActiveBrand = useCallback((brandKey) => {
    localStorage.setItem(STORAGE_KEY, brandKey);
    setActiveBrandState(brandKey);
    onBrandChange?.();
  }, [onBrandChange]);

  const activeBrandInfo = brands.find(b => b.key === activeBrand) || brands[0] || null;

  // Drives the brand accent palette (primary-* in tailwind.config.js, vars in index.css).
  const themeBrand = activeBrandInfo?.key;
  useEffect(() => {
    if (themeBrand) document.documentElement.dataset.brand = themeBrand;
    else delete document.documentElement.dataset.brand;
  }, [themeBrand]);

  return (
    <BrandContext.Provider value={{ brands, activeBrand, activeBrandInfo, setActiveBrand }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
